import { createUseStyles } from 'react-jss';
import { IonButtons, IonHeader, IonModal, IonTitle, IonToolbar, isPlatform } from '@ionic/react';
import { MenuCloseButton } from '../components/MenuCloseButton';

type IStyleKeys = 'modal' | 'modalHeader';
interface IStyleProps { desktopMaxHeight?: number; desktopMinHeight?: number; };

const useStyles = createUseStyles<IStyleKeys, IStyleProps>({
    modal: {
        '--max-height': ({ desktopMaxHeight }) => isPlatform('desktop') && desktopMaxHeight ? `${desktopMaxHeight}px` : undefined,
        '--min-height': ({ desktopMinHeight }) => isPlatform('desktop') && desktopMinHeight ? `${desktopMinHeight}px` : undefined
    },

    modalHeader: {
        '& ion-title': {
            paddingInlineStart: 16
        }
    }
});

type IModalProps = {
    'data-id'?: string;
    'data-type'?: string;
    title: string;
    children: React.ReactNode;
    isOpen: boolean;
    closeHandler: () => void;
    onWillPresent?: () => void;
    onDidPresent?: () => void;
    onWillDismiss?: () => void;
    onDidDismiss?: () => void;
    stackedModal?: boolean;
    keepContentsMounted?: boolean;
    desktopMaxHeight?: number;
    desktopMinHeight?: number;
    excludeAutoDismiss?: boolean;
};

export const Modal: React.FC<IModalProps> = ({
    'data-id': dataId,
    'data-type': dataType,
    title,
    children,
    isOpen = false,
    closeHandler,
    onWillPresent = () => {},
    onDidPresent = () => {},
    onWillDismiss = ()=>{},
    onDidDismiss = ()=>{},
    stackedModal = false,
    keepContentsMounted,
    desktopMaxHeight,
    desktopMinHeight,
    ...rest
}) => {
    const classes = useStyles({ desktopMaxHeight, desktopMinHeight });

    const handleIntercom = (modalOpen: boolean) => {
        if (!stackedModal) {
            // set a class on body to use for styling global elements
            // outside react (e.g. intercom launcher)
            document.body.classList[modalOpen ? 'add' : 'remove']('modal-presented');
        }
    };

    return (
        <IonModal
            {...rest} // do it this way so excludeAutoDismiss gets added without IDE complaining
            data-id={dataId}
            data-type={dataType}
            isOpen={isOpen}
            className={classes.modal}
            keepContentsMounted={keepContentsMounted}
            onWillPresent={() => {
                onWillPresent();
                handleIntercom(true);
            }}
            onDidPresent={onDidPresent}
            onWillDismiss={onWillDismiss}
            onDidDismiss={() => {
                onDidDismiss();
                handleIntercom(false);
            }}
        >
            <IonHeader translucent className={`ion-no-border ${classes.modalHeader}`}>
                <IonToolbar>
                    <IonTitle>{title}</IonTitle>
                    <IonButtons slot="end">
                        <MenuCloseButton onClick={closeHandler} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            {children}
        </IonModal>
    );
};
